<sk-text [floatLabel]="floatLabel"
         [matTooltip]="'label.EditDepartment' | translate"
         [matTooltipDisabled]="readonly || disabled"
         matTooltipPosition="left"
         (focusin)="openSelectorModal()"
         [placeholder]="label"
         [formControl]="valueControl"
         [disabled]="disabled"
         [readonly]="true"
         [hint]="hint"
         [hintRight]="hintRight"
         autocomplete="off"
         data-test="department-field-input"
         id="iris-department-field">

  @if (!(disabled || readonly) && valueControl.value) {
    <ng-template suffix>
      <sk-button appearance="icon"
                 data-test="department-field-clear-button"
                 aria-label="Clear"
                 class="at-button-clear"
                 (click)="clearValue($event)">
        <i class="fa-lg fal fa-times icon"></i>
      </sk-button>
    </ng-template>
  }

</sk-text>
